import {
  GET_VENDOR_MEMBER_COLUMNS_REQUEST,
  GET_VENDOR_MEMBER_COLUMNS_SUCCESS,
  GET_VENDOR_USER_COLUMNS_REQUEST,
  GET_VENDOR_USER_COLUMNS_SUCCESS,
  SET_VENDOR_USER_COLUMNS_REQUEST,
  SET_VENDOR_USER_COLUMNS_SUCCESS,
} from "./type";

export const getVendorMemberColumnsRequest = () => {
  return { type: GET_VENDOR_MEMBER_COLUMNS_REQUEST };
};

export const getVendorMemberColumnsSuccess = (data) => {
  return { type: GET_VENDOR_MEMBER_COLUMNS_SUCCESS, payload: data };
};

export const getVendorUserColumnsRequest = (vendorId) => {
  return { type: GET_VENDOR_USER_COLUMNS_REQUEST, payload: vendorId };
};

export const getVendorUserColumnsSuccess = (data) => {
  return { type: GET_VENDOR_USER_COLUMNS_SUCCESS, payload: data };
};

export const setVendorUserColumnsRequest = (data) => {
  return { type: SET_VENDOR_USER_COLUMNS_REQUEST, payload: data };
};

export const setVendorUserColumnsSuccess = (data) => {
  return { type: SET_VENDOR_USER_COLUMNS_SUCCESS, payload: data };
};
